<template>
  <router-link :to="to" :class="classes" :tag="tag" :disabled="disabled" v-if="external">
    <slot/>
  </router-link>
  <router-link :to="to" :class="classes" :tag="tag" :disabled="disabled" v-else>
    <slot/>
  </router-link>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "TextLink",
    props: {
      "to": {
        type: String,
        default: '',
      },
      "white": {
        type: Boolean
      },
      "primary": {
        type: Boolean
      },
      "blue": Boolean,
      external: Boolean,
      disabled: Boolean,
    },
    computed: {
      classes () {
        if (this.disabled) {
          return "disabled"
        }
        if (this.white) {
          return "white--text"
        }
        if (this.primary) {
          return "primary--text"
        }
        if (this.blue) {
          return "blue--text underline"
        }
        return "secondary--text font-weight-bold"
      },
      tag () {
        if (this.disabled) {
          return "button"
        }
        return "a"
      }
    }
  }
</script>

<style scoped lang="sass">
.underline
  text-decoration: underline
.disabled
  opacity: 0.5
</style>
